import { LazyString } from './LazyString';

const lazyGettext = (msgid: string, interpolation: Function) => {
    return new LazyString(msgid, interpolation);
};

export { lazyGettext, LazyString };
